export const BRAND = '#af0000'
export const BRAND_DARK = '#8B0000'
export const LEAP_RED = BRAND
export const LEAP_RED_RGB = '175, 0, 0'
export const LEAP_RED_DARK = BRAND_DARK
export const DOC_BLUSH = '#FDECEA'
export const SCAN_HERO_BG = '#0F172A'
export const SCAN_HERO_SOFT = '#1E293B'

/** Field capture / data-input app — pairs with RFID Control Tower. */
export const APP_NAME = 'RFID Operations'
export const APP_SUBTITLE = 'Scan & post'
export const APP_TAGLINE = 'Capture every tag. Post every move.'

export function leapRedRgba(alpha: number): string {
  return `rgba(${LEAP_RED_RGB}, ${alpha})`
}

export type ColorMode = 'light' | 'dark'

export function palette(mode: ColorMode = 'light') {
  const isDark = mode === 'dark'
  return {
    mode,
    brand: BRAND,
    brandDark: BRAND_DARK,
    background: isDark ? '#0B0B0C' : '#F4F6F8',
    surface: isDark ? '#141416' : '#FFFFFF',
    surface2: isDark ? '#19191B' : '#F5F5F5',
    text: isDark ? '#F5F5F5' : '#1A1A2E',
    mutedText: isDark ? '#A1A1AA' : '#6C757D',
    border: isDark ? '#27272A' : '#E0E0E0',
    hairline: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(26,26,46,0.06)',
    danger: '#EF4444',
    warning: '#F59E0B',
    success: '#10B981',
    info: '#3B82F6',
  }
}

export const SPACING = {
  screen: 16,
  card: 14,
  row: 12,
  radiusLg: 18,
  radiusMd: 14,
  radiusSm: 12,
} as const
